import { createTransform } from 'redux-persist';

const omitFields = (state, fieldsToOmit) => {
  if (!state || typeof state !== 'object' || Array.isArray(state)) {
    return state;
  }

  const sanitizedState = { ...state };
  fieldsToOmit.forEach((field) => {
    delete sanitizedState[field];
  });
  return sanitizedState;
};

/**
 * Filters inbound keys before reconciliation so a legacy transient value
 * cannot overwrite the reducer's initial value with undefined.
 */
export const createOmittingStateReconciler = (
  stateReconciler,
  fieldsToOmit
) => {
  const omittedFields = new Set(fieldsToOmit);
  return (inboundState, originalState, reducedState, config) => {
    const sanitizedInboundState = omitFields(inboundState, omittedFields);
    return stateReconciler(
      sanitizedInboundState,
      originalState,
      reducedState,
      config
    );
  };
};

/**
 * Sanitizes fields in a reducer's substate in both directions: before writing
 * and after reading. The shallow copy keeps all unrelated fields (and nested
 * references) unchanged.
 */
export const omitNestedPersistedFields = (stateKey, fieldsToOmit) => {
  const omittedFields = Array.from(fieldsToOmit);
  const sanitize = (subState, key) => {
    if (key !== stateKey || !subState || typeof subState !== 'object') {
      return subState;
    }

    return omitFields(subState, omittedFields);
  };

  return createTransform(sanitize, sanitize);
};
